import { render, staticRenderFns } from "./VariantSlider.vue?vue&type=template&id=420ec282&scoped=true&"
import script from "./VariantSlider.vue?vue&type=script&lang=js&"
export * from "./VariantSlider.vue?vue&type=script&lang=js&"
import style0 from "./VariantSlider.vue?vue&type=style&index=0&id=420ec282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420ec282",
  null
  
)

export default component.exports